import React from 'react';
import { Card, Alert, Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Atualiza o state para mostrar a UI de fallback
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log do erro para debugging
    console.error('ErrorBoundary capturou um erro:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });

    // Aqui você pode enviar o erro para um serviço de logging se necessário
    // logErrorToService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const { fallback: FallbackComponent } = this.props;
      // Se há um componente de fallback customizado, use-o
      if (FallbackComponent) {
        return <FallbackComponent error={this.state.error} />;
      }

      // UI de fallback padrão
      return (
        <Container className="py-5">
          <Row className="justify-content-center">
            <Col md={8} lg={6}>
              <Card className="text-center">
                <Card.Body className="p-5">
                  <div className="display-1 text-300 fs-error">
                    <FontAwesomeIcon
                      icon="exclamation-triangle"
                      className="text-warning"
                    />
                  </div>
                  <h1 className="text-800 mb-3">Oops!</h1>
                  <p className="text-700 mb-4">
                    Algo deu errado. Por favor, atualize a página ou tente
                    novamente.
                  </p>
                  {process.env.NODE_ENV === 'development' && (
                    <Alert variant="danger" className="text-start">
                      <details>
                        <summary>Detalhes do erro (desenvolvimento)</summary>
                        <pre className="mt-2">
                          {this.state.error && this.state.error.toString()}
                          <br />
                          {this.state.errorInfo.componentStack}
                        </pre>
                      </details>
                    </Alert>
                  )}
                  <div className="d-flex justify-content-center gap-2">
                    <button
                      className="btn btn-primary"
                      onClick={() => window.location.reload()}
                    >
                      <FontAwesomeIcon icon="refresh" className="me-1" />
                      Recarregar Página
                    </button>
                    <button
                      className="btn btn-outline-secondary"
                      onClick={() => window.history.back()}
                    >
                      <FontAwesomeIcon icon="arrow-left" className="me-1" />
                      Voltar
                    </button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
